import { Link } from 'react-router-dom'
import Footer from '../../components/layout/Footer'

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-paper text-ink">
      <header className="border-b border-line">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo-ax.svg" alt="ax-kanban" className="h-10 w-auto" />
          </Link>
          <Link to="/login" className="text-sm text-brand-600 dark:text-brand-300 hover:text-brand-700 dark:text-brand-300 font-medium">
            Voltar ao login →
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold mb-2">Política de Privacidade</h1>
        <p className="text-sm text-ink-faint">Última atualização: 14 de maio de 2026</p>

        <p className="mt-6 text-ink-muted">
          Esta Política descreve como a BX Solutions (operada pela <strong>Ax Business & Solutions</strong>)
          trata dados pessoais coletados na utilização da plataforma, em conformidade com a
          <strong> Lei Geral de Proteção de Dados Pessoais (LGPD — Lei 13.709/2018)</strong>.
        </p>

        <section className="mt-8 space-y-6 text-ink-muted">
          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">1. Controlador e DPO</h2>
            <p>
              <strong>Controlador:</strong> Ax Business & Solutions, com sede no Brasil.
              <br />
              <strong>Encarregado de Dados (DPO):</strong> <a href="mailto:dpo@bx.tec.br" className="text-brand-600 dark:text-brand-300 hover:underline">dpo@bx.tec.br</a>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">2. Dados Coletados</h2>
            <p>Coletamos e tratamos as seguintes categorias de dados:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Dados de cadastro:</strong> e-mail, nome (quando informado) e função (admin/operador) na empresa.</li>
              <li><strong>Dados de autenticação:</strong> senha (armazenada com hash criptográfico pelo provedor Supabase Auth), tokens de sessão.</li>
              <li><strong>Dados operacionais da empresa:</strong> produtos, fornecedores, vendas, pedidos de compra — inseridos pelos próprios usuários.</li>
              <li><strong>Dados de integração:</strong> tokens OAuth para ERP Tiny (criptografados em repouso).</li>
              <li><strong>Logs técnicos:</strong> IP, user-agent, timestamps de acesso, erros (via Sentry), para diagnóstico e segurança.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">3. Finalidades e Bases Legais</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Execução de contrato (Art. 7º, V):</strong> autenticação, prestação do serviço de reposição de estoque, geração de relatórios e pedidos.</li>
              <li><strong>Legítimo interesse (Art. 7º, IX):</strong> segurança da plataforma, prevenção a fraudes, métricas agregadas de uso.</li>
              <li><strong>Cumprimento de obrigação legal (Art. 7º, II):</strong> retenção de registros fiscais/contábeis quando aplicável.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">4. Compartilhamento com Terceiros (Operadores)</h2>
            <p>Utilizamos os seguintes operadores subprocessadores, sempre com cláusulas contratuais de proteção de dados:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Supabase</strong> (infraestrutura de banco de dados e autenticação) — dados armazenados em São Paulo (sa-east-1).</li>
              <li><strong>Vercel</strong> (hospedagem do frontend) — sem armazenamento persistente de dados pessoais.</li>
              <li><strong>Resend</strong> (envio de e-mails transacionais) — apenas e-mail do destinatário e corpo da mensagem.</li>
              <li><strong>Tiny ERP</strong> (integração opt-in pelo cliente) — sincronização de produtos/vendas autorizada explicitamente.</li>
              <li><strong>Sentry</strong> (observabilidade de erros) — apenas dados técnicos (stack trace, ambiente). Não enviamos PII por padrão.</li>
            </ul>
            <p className="mt-2">
              Não vendemos, alugamos ou cedemos dados pessoais para terceiros com finalidade comercial.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">5. Transferência Internacional</h2>
            <p>
              Os dados são armazenados em São Paulo (Brasil) na infraestrutura Supabase. Alguns
              operadores (Sentry, Resend, Vercel) podem processar metadados em outras jurisdições;
              nesses casos, garantimos cláusulas contratuais padrão e nível de proteção adequado
              conforme Art. 33 da LGPD.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">6. Retenção e Eliminação</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Conta ativa:</strong> dados retidos enquanto o cliente utiliza o serviço.</li>
              <li><strong>Após pedido de exclusão:</strong> conta marcada como excluída com <strong>grace period de 30 dias</strong> (período em que o usuário pode reverter a exclusão); após esse prazo, os dados são eliminados de forma irreversível.</li>
              <li><strong>Logs e dados de auditoria:</strong> retidos por até 12 meses para fins de segurança e compliance.</li>
              <li><strong>Obrigações legais:</strong> dados financeiros e contábeis podem ser retidos por prazo maior conforme exigência legal.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">7. Direitos do Titular</h2>
            <p>Conforme Art. 18 da LGPD, você pode, a qualquer momento, exercer os seguintes direitos:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Acesso:</strong> obter cópia dos seus dados (use o botão "Exportar meus dados" em Configurações → Conta);</li>
              <li><strong>Correção:</strong> atualizar dados incompletos ou desatualizados;</li>
              <li><strong>Eliminação:</strong> solicitar exclusão dos dados (botão "Excluir minha conta" em Configurações → Conta);</li>
              <li><strong>Portabilidade:</strong> receber dados em formato estruturado (JSON, via exportação);</li>
              <li><strong>Informação sobre compartilhamento:</strong> ver seção 4 acima;</li>
              <li><strong>Revogação de consentimento:</strong> quando o tratamento for baseado em consentimento.</li>
            </ul>
            <p className="mt-2">
              Para exercer qualquer direito que não esteja disponível diretamente no app,
              contate o DPO em <a href="mailto:dpo@bx.tec.br" className="text-brand-600 dark:text-brand-300 hover:underline">dpo@bx.tec.br</a> — responderemos em até 15 dias.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">8. Segurança</h2>
            <p>Adotamos as seguintes medidas técnicas e organizacionais:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Senhas armazenadas com hash criptográfico (bcrypt via Supabase Auth);</li>
              <li>Conexões em HTTPS/TLS;</li>
              <li>Isolamento multi-tenant via Row Level Security no banco;</li>
              <li>Tokens de integração criptografados em repouso;</li>
              <li>Monitoramento contínuo via Sentry;</li>
              <li>Backups regulares e plano de recuperação documentado.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">9. Cookies</h2>
            <p>
              Utilizamos apenas cookies estritamente necessários para autenticação e
              funcionamento da plataforma. Não usamos cookies de rastreamento publicitário
              nem compartilhamos identificadores com redes ad-tech.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">10. Incidentes</h2>
            <p>
              Em caso de incidente de segurança envolvendo dados pessoais, notificaremos a
              ANPD e os titulares afetados nos prazos previstos pela LGPD (Art. 48), com
              descrição dos dados envolvidos, riscos e medidas adotadas.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">11. Alterações desta Política</h2>
            <p>
              Alterações materiais serão comunicadas por e-mail aos administradores das
              empresas contratantes com pelo menos 15 dias de antecedência. A versão vigente
              estará sempre publicada nesta URL.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-ink mb-2">12. Contato e Reclamações</h2>
            <p>
              <strong>DPO:</strong> <a href="mailto:dpo@bx.tec.br" className="text-brand-600 dark:text-brand-300 hover:underline">dpo@bx.tec.br</a><br />
              <strong>Suporte:</strong> <a href="mailto:contato@bx.tec.br" className="text-brand-600 dark:text-brand-300 hover:underline">contato@bx.tec.br</a><br />
              <strong>ANPD:</strong> em caso de não resolução, você pode acionar a Autoridade Nacional de Proteção de Dados em <a href="https://www.gov.br/anpd" target="_blank" rel="noopener noreferrer" className="text-brand-600 dark:text-brand-300 hover:underline">www.gov.br/anpd</a>.
            </p>
          </div>
        </section>
      </main>

      <Footer variant="light" />
    </div>
  )
}
